var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.282 8.48s10.084-4.14 13.581-5.597c1.341-.582 5.888-2.448 5.888-2.448s2.098-.816 1.923 1.166c-.058.816-.525 3.672-.99 6.762-.7 4.371-1.458 9.15-1.458 9.15s-.117 1.341-1.108 1.575c-.99.233-2.623-.816-2.914-1.05-.233-.174-4.372-2.797-5.887-4.08-.408-.35-.874-1.049.058-1.865 2.099-1.924 4.605-4.313 6.12-5.829.7-.7 1.4-2.331-1.515-.35-4.139 2.857-8.219 5.538-8.219 5.538s-.932.583-2.681.058c-1.749-.524-3.789-1.224-3.789-1.224s-1.399-.874.991-1.807z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.39f8b49a75e4645bac5ad5303338ef4d.svg";
export { ForwardRef as ReactComponent };